import { __assign, __rest } from "tslib";
import * as React from 'react';
import { default as MuiLinearProgress, } from '@material-ui/core/LinearProgress';
import { Typography } from '../../Typography';
import { getColor, makeStyles, createStyles } from '../../styles';
export var useStyles = makeStyles(function (theme) {
    var errorBackground = theme.palette.type === 'light' ? theme.palette.error.light : theme.palette.error.dark;
    var progressBorder = theme.palette.type === 'light'
        ? getColor('text.primary', 'dark')
        : getColor('text.primary', 'light');
    return createStyles({
        root: {
            border: "1px solid ".concat(progressBorder),
            width: '100%',
        },
        colorComplete: {
            backgroundColor: getColor('success.main', theme),
        },
        colorCompleteBar: {
            backgroundColor: getColor('success.main', theme),
            border: "2px solid ".concat(theme.palette.success.main),
        },
        colorError: {
            backgroundColor: errorBackground,
        },
        colorErrorBar: {
            backgroundColor: getColor('error.main', theme),
            border: "2px solid ".concat(theme.palette.error.main),
        },
        valueLabel: {
            fontWeight: 'bold',
            textAlign: 'center',
            width: 'inherit',
        },
    });
});
var colorPrimaryStateColor = function (props, styles) {
    var error = props.error, value = props.value;
    if (error) {
        return styles.colorError;
    }
    if (value === 100) {
        return styles.colorComplete;
    }
    return undefined;
};
var barColorPrimaryStateColor = function (props, styles) {
    var error = props.error, value = props.value;
    if (error) {
        return styles.colorErrorBar;
    }
    if (value === 100) {
        return styles.colorCompleteBar;
    }
    return undefined;
};
export var LinearProgress = function (props, ref) {
    var classes = props.classes, id = props.id, maxValue = props.maxValue, minValue = props.minValue, value = props.value, variant = props.variant, error = props.error, withAriaProps = __rest(props, ["classes", "id", "maxValue", "minValue", "value", "variant", "error"]);
    var _a = withAriaProps, ariaLabel = _a.ariaLabel, withLabelProps = __rest(_a, ["ariaLabel"]);
    var _b = withLabelProps, label = _b.label, labelProps = _b.labelProps, other = __rest(_b, ["label", "labelProps"]);
    var styles = useStyles(props);
    var colorPrimary = colorPrimaryStateColor(props, styles);
    var barColorPrimary = barColorPrimaryStateColor(props, styles);
    if (label && !id) {
        throw new Error("The id must be supplied when using an on-screen label");
    }
    if (variant === 'determinate') {
        return (React.createElement(React.Fragment, null,
            React.createElement(MuiLinearProgress, __assign({ ref: ref, variant: variant, className: styles.root, classes: __assign({ colorPrimary: colorPrimary, barColorPrimary: barColorPrimary }, classes), value: value, "aria-valuemin": minValue !== null && minValue !== void 0 ? minValue : 0, "aria-valuemax": maxValue !== null && maxValue !== void 0 ? maxValue : 100, "aria-valuetext": label, "aria-label": ariaLabel }, other)),
            React.createElement(Typography, __assign({ component: "p", variant: "h4", className: styles.valueLabel }, labelProps), label)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MuiLinearProgress, __assign({ ref: ref, className: "".concat(styles.root), classes: __assign({ colorPrimary: colorPrimary, barColorPrimary: barColorPrimary }, classes), value: undefined, role: "status", "aria-valuemin": undefined, "aria-valuemax": undefined, "aria-label": !label ? ariaLabel : undefined, "aria-labelledby": label ? "linear-text-".concat(id) : undefined }, other)),
        label ? (React.createElement(Typography, __assign({ id: "linear-text-".concat(id), component: "p", variant: "h4", className: styles.valueLabel }, labelProps), label)) : null));
};
var LinearProgressRef = React.forwardRef(LinearProgress);
export default LinearProgressRef;
//# sourceMappingURL=LinearProgress.js.map